@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<h1 mat-dialog-title>
  Confirm Payment
</h1>

<div mat-dialog-content>
  <p>Are you sure want to confirm payment?</p>
</div>

<div mat-dialog-actions>
  <button mat-flat-button class="error border-2 shade" (click)="closeDialog()">No</button>
  <button mat-flat-button class="shade border-2" (click)="onConfirm()">Yes</button>
</div>